export default __webpack_public_path__ + "static/media/minivistaw-camioneschatos.0f81cd86.jpg";